(function () {
    function DICompanyUtil() {
      "use strict";
      var context = this;
      context.name = "CompanyUtil";  
      context.init = function () { };
      
      context.parseUrlParams = function (query) {
        query = typeof query != "string" ? "" : query.substr(query.indexOf("?") + 1);
        var query_string = {};
  
        if (query !== "") {
          var vars = query.split("&");
  
          for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            var key = decodeURIComponent(pair[0]);
            var value = decodeURIComponent(pair[1]);
  
            if (typeof query_string[key] === "undefined") {
              query_string[key] = decodeURIComponent(value);
            } else if (typeof query_string[key] === "string") {
              query_string[key] = [query_string[key], decodeURIComponent(value)];
            } else {
              query_string[key].push(decodeURIComponent(value));
            }
          }
        } else {
          console.warn("Invalid query string supplied to parseUrlParams.");
        }
  
        return query_string;
      };
  
      context.serializeUrlParams = function (obj) {
        var str = [];
  
        for (var p in obj) {
          str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        }
  
        return "?" + str.join("&");
      };
  
  
      context.convertObjectToQueryString = function (object) {
        var string = "",
          i = 0;
  
        for (var j in object) {
          var s = encodeURIComponent(j) + "=" + encodeURIComponent(object[j]);
          string += i > 0 ? "&" + s : s;
          i++;
        }
  
        return string;
      };
  
  
      context.collectFormData = function (form) {
        if (form === undefined || form === null) {
          return false;
        }
  
        var data = {};
  
        for (var i = 0; i < form.elements.length; i++) {
          var field = form.elements[i];
          if (!field.name || field.type === "file" || field.type === "reset" || field.type === "submit" || field.type === "button") continue;
          if (field.disabled && field.tagName !== "SELECT") continue;
  
          if (field.type === "select-multiple") {
            data[field.name] = [];
  
            for (var n = 0; n < field.options.length; n++) {
              if (!field.options[n].selected) continue;
              data[field.name].push(field.options[n].value);
            }
          } else if (field.type !== "checkbox" && field.type !== "radio" || field.checked) {
            data[field.name] = field.value;
          }
        }
  
        return data;
      };
  
      context.showNotification= function showNotification(type, title, description) {
          $.toast({
            type: type==2?'error':'info',
            title: title,
            subtitle: '',
            content: description,
            delay: 3000
  
          });
        
      };
      return this;
    };
    var DICompanyUtilInstance = new DICompanyUtil();
    window.DIMainInstance.injectReference(DICompanyUtilInstance.name, DICompanyUtilInstance);
    DICompanyUtilInstance.init();
  })();